import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
// import logga from "../../components/auth/Logga_vit_ren.png";
import logga from "../../components/auth/Evisens_Logga_vit_ren.png";
import backgroundImage from "./background-image.png"
import bankIdLogoWhite from "../../components/auth/BankID_logo_white.png";
import bankIdLogoBlack from "../../components/auth/BankID_logo_black.png";
// import logoAndtext from "../../components/auth/logAndText.png";
import logoAndtext from "../../components/auth/EvisensLogoAndText.png";
import { Navigate } from "react-router-dom";
import {
  login,
  eIdBegin,
  eidlogin,
  resetAuthUserError,
} from "../../reducers/authUserSlice.js";
import { useDispatch, useSelector } from "react-redux";

function Login(props) {
  const dispatch = useDispatch();
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const isAuthenticated = useSelector(
    (state) => state.authUser.isAuthenticated
  );
  const eidPending = useSelector((state) => state.authUser.eidPending);
  const statedata = useSelector((state) => state.authUser.data);

  const authuserReqStatus = useSelector((state) => state.authUser.status);
  const authErrors = useSelector((state) => state.authUser.error);
  const [emailError, setEmailError] = useState(null);
  const [loginError, setLoginError] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const transaction_id = searchParams.get("transaction_id");

  useEffect(() => {
    return function cleanUp() {
      console.log("effect cleanup");
      dispatch(resetAuthUserError());
    };
  }, []);

  useEffect(() => {
    if (authuserReqStatus === "rejected") {
      if (authErrors && authErrors.email) {
        setEmailError(authErrors.email);
        setLoginError(false);
      } else {
        setEmailError(null);
        setLoginError(true);
      }
    } else {
      setEmailError(null);
      setLoginError(false);
    }
  }, [authuserReqStatus]);

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(login({ email: email, password: password }));
  };

  const onEIdSubmit = (e) => {
    e.preventDefault();
    setSearchParams("transaction_id", "");
    dispatch(eIdBegin());
  };

	if (eidPending) {
		if (transaction_id) {
			dispatch(eidlogin({ transaction_id: transaction_id }));
			return "";
		}
		else {
			window.location.href = statedata["accessUrl"];
			return "";
		}
	}
	if (isAuthenticated) {
		// error if user is undefined.
		return <Navigate to={"/dashboard"} />;
	} else {
		return (
			<div
				style={{
					minHeight: "100vh",
					width: "100vw",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					backgroundImage: `radial-gradient(circle at center, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.45) 100%), url(${backgroundImage})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				<div>
					{/* <div className="textAndLogo">
						<img src={logoAndtext} style={{ maxWidth: "230px" }} alt=""></img>
					</div> */}

					<div className="container loginscreen">
						<div className="row">
							<div className="loginContainer">
								<div id="logoContainer">
									<img id="coin-logo" src={logga} alt="loggo"></img>
								</div>
								<br />
								<div className="loginText">
									<p className="login-h1">Kundportal</p>
								</div>

								<form noValidate onSubmit={onSubmit}>
									<div className="input-field">
										<input
											onChange={(e) => setEmail(e.target.value)}
											// value={email}
											placeholder={"E-mail"}
											id="email"
											type="email"
											className="loginInput"
										/>
										{emailError ? (
											<span style={{ color: "red" }}>{emailError}</span>
										) : null}
									</div>
									<div className="input-field">
										<input
											onChange={(e) => setPassword(e.target.value)}
											// value={password}
											placeholder={"Lösenord"}
											id="password"
											type="password"
											className="loginInput"
										/>
									</div>
									<div className="loginButtonContainer">
										<button type="submit" className="loginBtn">
											Login
										</button>
									</div>
								</form>
								{loginError ? (
									<span style={{ color: "red" }}>Kunde inte logga in</span>
								) : null}
								<div>
									<p />
									<form noValidate onSubmit={onEIdSubmit}>
										<div className="loginButtonContainer">
											<button type="submit" className="loginBtn bankIdBtn">
														<img
															src={bankIdLogoWhite}
															alt="BankID"
															className="bankIdLogo bankIdLogoWhite"
														/>
														<img
															src={bankIdLogoBlack}
															alt="BankID"
															className="bankIdLogo bankIdLogoBlack"
														/>
												<span>BankID</span>
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Login;
